import { render } from "./UtilButton.vue?vue&type=template&id=50bb5dcc&scoped=true"
import script from "./UtilButton.vue?vue&type=script&lang=js"
export * from "./UtilButton.vue?vue&type=script&lang=js"

import "./UtilButton.vue?vue&type=style&index=0&id=50bb5dcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bb5dcc"]])

export default __exports__